// eslint-disable-next-line no-shadow
export var IPublicEnumTransitionType = /*#__PURE__*/function (IPublicEnumTransitionType) {
  IPublicEnumTransitionType[IPublicEnumTransitionType["REPAINT"] = 0] = "REPAINT";
  return IPublicEnumTransitionType;
}({});

/**
 * @deprecated use IPublicEnumTransitionType instead
 */
export var TransitionType = /*#__PURE__*/function (TransitionType) {
  TransitionType[TransitionType["REPAINT"] = 0] = "REPAINT";
  return TransitionType;
}({});